import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {parseStringToHtmlAndSanitize} from '../../../util/htmlString';
import {PageContainer, PageDescription, PageTitle, Spinner, ButtonGroup, Button} from '../../Common/PageComponents';
import ToggleTabs, {Tab} from '../../Common/ToggleTabs';
import './Faqs.scss';
import {useContentStack} from '../../Common/PcBangContentStack';
import ShowMore from '@tedconf/react-show-more';

const tabs = [
  {
    key: 'ALL',
    link: '/customer/faqs/all/1',
    name: '전체',
  },
  {
    key: 'MEMBERSHIP',
    link: '/customer/faqs/membership/1',
    name: '가입/탈퇴/정보',
  },
  {
    key: 'PAYMENT',
    link: '/customer/faqs/payment/1',
    name: '결제/상품',
  },
  {
    key: 'PAYMENTCANCEL',
    link: '/customer/faqs/paymentcancel/1',
    name: '결제취소/환불',
  },
  {
    key: 'CHANGEOWNER',
    link: '/customer/faqs/changeowner/1',
    name: '명의변경',
  },
  {
    key: 'TAXINVOICE',
    link: '/customer/faqs/taxinvoice/1',
    name: '세금계산서',
  },
  {
    key: 'OTHER',
    link: '/customer/faqs/other/1',
    name: '기타',
  },
];

const Faqs = props => {
  const faqs = useContentStack('pcb_faq', 'url');
  const initCategory = tabs.filter(tab => tab.key.toLowerCase() === props.match.params.category).pop() || tabs[0];
  const [category, setCategory] = useState(initCategory);

  if (faqs === 'fetching') return <Spinner />;

  return (
    <PageContainer>
      <PageTitle title={'FAQ'} />
      <PageDescription>자주 문의하는 질문에 대한 답변을 찾을 수 있습니다.</PageDescription>
      <ToggleTabs theme={'blue'}>
        {tabs.map(tab => (
          <Tab key={tab.key} active={tab.name === category.name}>
            <Link to={tab.link} onClick={() => setCategory(tab)}>
              {tab.name}
            </Link>
          </Tab>
        ))}
      </ToggleTabs>
      <ShowMore items={faqs.filter(faq => faq.tags.includes(category.name) || category.name === '전체')} by={10}>
        {({current, onMore}) => (
          <div>
            <ul>
              {current.map((faq, index) => (
                <li className="faq" key={index}>
                  <p className="question">
                    <strong>[{faq.tags.toString()}]</strong> {faq.title}
                  </p>
                  <p className="answer" dangerouslySetInnerHTML={parseStringToHtmlAndSanitize(faq.rich_text_editor)} />
                </li>
              ))}
            </ul>
            {onMore && (
              <ButtonGroup>
                <Button onClick={onMore} theme={'gray'}>
                  더보기 ({current.length}/{faqs.length})
                </Button>
              </ButtonGroup>
            )}
          </div>
        )}
      </ShowMore>
    </PageContainer>
  );
};

export default Faqs;
